export default {"src":"/_next/static/media/bridge-own.4dec5ac4.svg","height":100,"width":100};